import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import {Router} from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    loading: boolean = false;
//    public settings: Settings;
    isUnderMaintenance: boolean = false;
    timer = ms => new Promise(res => setTimeout(res, ms))
    isTokenValid: boolean = false;
    
    
    idleState = 'Not started.';
    timedOut = false;
    lastPing?: Date = null;
    title = 'angular-idle-timeout';
    
    
    constructor(public  http: HttpClient,private idle: Idle, private keepalive: Keepalive,public router: Router) {
    }

    ngOnInit() {
        this.getSecuredAuthToken();
        this.inactiveTimeOut();
    }
    
    
    inactiveTimeOut(){
        // sets an idle timeout of 30 min, for testing purposes.
//        15 min == 900 sec.
//        30 min == 1800 sec.
//        60 min == 3600 sec.
        this.idle.setIdle(10800);
        // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
        this.idle.setTimeout(10);
        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

        this.idle.onIdleEnd.subscribe(() => {
            this.idleState = 'No longer idle.'
            console.log(this.idleState);
            this.reset();
        });

        this.idle.onTimeout.subscribe(() => {
            this.idleState = 'Timed out!';
            this.timedOut = true;
            console.log(this.idleState);
            localStorage.removeItem('isLoggedin');
            localStorage.clear();
            this.router.navigate(['/login']);
        });

        this.idle.onIdleStart.subscribe(() => {
            this.idleState = 'You\'ve gone idle!'
            console.log(this.idleState);
//            this.childModal.show();
        });

        this.idle.onTimeoutWarning.subscribe((countdown) => {
            this.idleState = 'You will time out in ' + countdown + ' seconds!'
//            alert('You will time out in ' + countdown + ' seconds!');
            console.log(this.idleState);
        });

        // sets the ping interval to 15 seconds
        this.keepalive.interval(15);

        this.keepalive.onPing.subscribe(() => this.lastPing = new Date());

        this.reset();
    }
    
    reset() {
        this.idle.watch();
        this.idleState = 'Started.';
        this.timedOut = false;
    }
    
    
    async getSecuredAuthToken()
    {
//        while(true)
//        {
//            this.http.get("/api/auth/token").subscribe(data=>{
//                this.isTokenValid = true;
//                console.log(data);
//            })
////            await this.timer(3000000); 
//            await this.timer(90000); 
////            await this.timer(5000); 
//        }
    }
}
